<template>
    <Selectable
        v-slot="selectable"
        :value="preDefinedAvailabilityType"
        v-model="modelValue"
        @click="updateValue()"
    >
        <Card
            :isActive="selectable.active"
            :shouldHighlightOnHover="true"
        >
            <template #content>
                <div class="space-y-2">
                    <div class="text-lg font-bold text-gray-900">
                        {{ title }}
                    </div>
                    <div class="text-sm font-normal text-gray-500">
                        {{ description }}
                    </div>
                </div>
            </template>
        </Card>
    </Selectable>
</template>

<script setup lang="ts">
    import Card from '@/Shared/Component/Card.vue'
    import Selectable from '@/Shared/Component/Selectable.vue'
    import type { PreDefinedAvailabilityTypeEnum } from '@/Shared/AutoGenerated/Main'

    const modelValue = defineModel<PreDefinedAvailabilityTypeEnum>()

    const props = defineProps({
        preDefinedAvailabilityType: {
            type: String as () => PreDefinedAvailabilityTypeEnum,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
    })

    const updateValue = (): void => {
        modelValue.value = props.preDefinedAvailabilityType
    }
</script>
